module.exports = __webpack_public_path__ + "c71fa8eddd07165bf64b2f6b585cfc2c.png";